export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aerial%20overhead%20view%20of%20beautifully%20curated%20fashion%20items%20including%20designer%20sneakers%20folded%20denim%20silver%20watch%20sunglasses%20and%20a%20leather%20bag%20arranged%20on%20a%20light%20oak%20wooden%20table%20bright%20natural%20daylight%20from%20large%20window%20editorial%20flat%20lay%20photography%20high%20resolution%20luxury%20aesthetic%20clean%20shadows&width=1600&height=900&seq=hero-bg-v2-main&orientation=landscape"
        alt="Curated pandabuy spreadsheet fashion finds flat lay"
        title="PandaBuy Spreadsheet Hub - Curated Fashion Finds"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/55" />

      <div className="relative z-10 w-full text-center px-4 md:px-6 pt-20 pb-10">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-4xl mx-auto text-balance">
          The Ultimate{" "}
          <span className="italic font-semibold">pandabuyspreadsheet</span>{" "}
          Hub for 2026
        </h1>
        <p className="mt-5 text-sm md:text-base lg:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          Discover curated PandaBuy spreadsheet finds, viral replica lists, and budget-to-luxury
          shopping collections updated daily. Thousands of pandabuyspreadsheet entries organized
          into clean, searchable lists so you can find the best items in seconds — not hours.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white text-foreground-900 text-sm md:text-base font-semibold hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            pandabuy sheet
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500">
              <i className="ri-arrow-right-up-line text-white text-xs"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            buy it now
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/20">
              <i className="ri-arrow-right-up-line text-white text-xs"></i>
            </span>
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-3">
            <i className="ri-refresh-line text-white/90 text-lg"></i>
            <span className="text-white/85 text-sm font-medium">Updated Daily</span>
          </div>
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-3">
            <i className="ri-database-2-line text-white/90 text-lg"></i>
            <span className="text-white/85 text-sm font-medium">1000+ Curated Items</span>
          </div>
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-3">
            <i className="ri-fire-line text-white/90 text-lg"></i>
            <span className="text-white/85 text-sm font-medium">Viral TikTok &amp; Reddit Finds</span>
          </div>
        </div>

        <div className="mt-14">
          <button
            onClick={() => {
              document.getElementById("categories")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            <span className="text-sm">Explore Categories</span>
            <i className="ri-arrow-down-line animate-bounce"></i>
          </button>
        </div>
      </div>
    </section>
  );
}